<template>
  <div class="user-review-header col-12 pt-1">
    <!-- <h2 class="my-xxs-3 my-md-0">
      <strong>{{ $t('UserReview.CommentsAndReviews') }}</strong>
    </h2> -->
    <div class="d-flex flex-xxs-column flex-md-row justify-content-center">
      <!-- <section class="d-flex flex-xxs-column flex-md-row align-items-xxs-center col-xxs-12 col-md-6">
        <section class="d-flex flex-column col-xxs-12 col-md-3">
          <span class="point align-self-center">
            {{ totalReview.rate }}
          </span>
          <div class="d-flex justify-content-center">
            <VueStars
              name="totalRate"
              :readonly="true"
              :value="totalReview.star"
              active-color="$black"
            />
            <span class="total-vote p-2">
              {{ totalReview.numberOfReviews }}
            </span>
          </div>
        </section>
        <section
          class="d-flex flex-column py-3 col-xxs-12 col-md-8"
        >
          <div class="d-flex align-items-center">
            <span class="align-self-strech">
              5
            </span>
            <img height="24" src="@/assets/icons/star-disabled.svg">
            <b-progress
              :key="'dark'"
              class="col-9"
              :value="totalReview.fiveStarPercent"
              :variant="'dark'"
            />
            <small class="col-1">
              {{ totalReview.fiveStarPercent }}%
            </small>
          </div>
          <div class="d-flex align-items-center">
            <span class="align-self-strech">
              4
            </span>
            <img height="24" src="@/assets/icons/star-disabled.svg">
            <b-progress
              :key="'dark'"
              class="col-9"
              :value="totalReview.fourStarPercent"
              :variant="'dark'"
            />
            <small class="col-1">
              {{ totalReview.fourStarPercent }}%
            </small>
          </div>
          <div class="d-flex align-items-center">
            <span class="align-self-strech">
              3
            </span>
            <img height="24" src="@/assets/icons/star-disabled.svg">
            <b-progress
              :key="'dark'"
              class="col-9"
              :value="totalReview.threeStarPercent"
              :variant="'dark'"
            />
            <small class="col-1">
              {{ totalReview.threeStarPercent }}%
            </small>
          </div>
          <div class="d-flex align-items-center">
            <span class="align-self-strech">
              2
            </span>
            <img height="24" src="@/assets/icons/star-disabled.svg">
            <b-progress
              :key="'dark'"
              class="col-9"
              :value="totalReview.twoStarPercent"
              :variant="'dark'"
            />
            <small class="col-1">
              {{ totalReview.twoStarPercent }}%
            </small>
          </div>
          <div class="d-flex align-items-center">
            <span class="align-self-strech">
              1
            </span>
            <img height="24" src="@/assets/icons/star-disabled.svg">
            <b-progress
              :key="'dark'"
              class="col-9"
              :value="totalReview.oneStarPercent"
              :variant="'dark'"
            />
            <small class="col-1">
              {{ totalReview.oneStarPercent }}%
            </small>
          </div>
        </section>
      </section> -->
      <section class="d-flex flex-column align-items-center my-3">
        <b-button
          class="px-5 mx-2"
          variant="success"
          @click="showUserReviewModal(0)"
        >
          {{ $t('UserReview.SubmitComment') }}
        </b-button>
        <!-- <VueStars
          class="star-rate d-flex align-items-center"
          name="rate"
          :readonly="false"
          :value="0"
          @input="showUserReviewModal"
        /> -->
        <StarRating 
      :max-rating="5" 
      :star-size="30" 
      :round-start-rating="true"
      :border-width="0"
      inactive-color="#a1a1a1"
      :rating="userProductRate ? userProductRate.ratePoint:0"
      :show-rating="false" 
      class="star-rate d-flex align-items-center my-2"
      @rating-selected="submitRate"/>
      </section>
    </div>
  </div>
</template>

<script>
import VueStars from '@/components/VueStars.vue'
import StarRating from 'vue-star-rating'

export default {
  name: 'UserReviewHeader',
  components: {
    VueStars,
    StarRating
  },
  props: {
    totalReview: Object,
    userProductRate: Object
  },
  methods: {
    showUserReviewModal (rate) {
      if(this.userProductRate && this.userProductRate.hasComment)
      {
        this.$bvToast.toast(this.$t('UserReview.HasComment'), {
                title: this.$t('UserProfile.Subscription.BuySubscriptionFactor.warning'),
                autoHideDelay: 3000,
                appendToast: true,
                variant: 'warning',
                solid: true
        })
      }
      else{
      this.$emit('showUserReviewModal', rate)
      }
    },
    submitRate(rate)
    {
      this.$emit('submitRate',rate)
    }
  },
}
</script>
